import { CodeBase } from "./_codeBase";

/**
 * 単純にフラグ
 */
export class Flag extends CodeBase<Flag>
{
    /** フラグ: "01", "<半角スペース> " */
    //空文字だとSpreadのコンボボックスが機能しないようである
    //public static readonly UNLOCK: AccountLockDiv = new AccountLockDiv("01", "ロック状態でない場合",'');
    //#862 Text値未設定のコンボボックスについて(空文字問題解消)
    //public static readonly FALSE: Flag = new Flag(false, " ", '-');
    public static readonly FALSE: Flag = new Flag(false, '', '');
    
    /** フラグ: "02", "○" */
    public static readonly TRUE: Flag = new Flag(true, "○", '○');

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): Flag[] {
        return [
            Flag.TRUE,
            Flag.FALSE,
        ];
    }
}
